import { render, staticRenderFns } from "./BoletoCard.vue?vue&type=template&id=383455b4&scoped=true"
import script from "./BoletoCard.vue?vue&type=script&lang=js"
export * from "./BoletoCard.vue?vue&type=script&lang=js"
import style0 from "./BoletoCard.vue?vue&type=style&index=0&id=383455b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383455b4",
  null
  
)

export default component.exports